import { useToast } from '@ordr-as/umami-react/toast';
import { useIntl } from 'react-intl';
import { PrintReceiptDtoTypeEnum } from '../../generated-api';
import { useMutatePrintReceipt } from './useReceiptApi';
import { useCallback, useMemo } from 'react';

const usePrintReceipt = (onSuccess: () => void = () => undefined) => {
  const { mutate: print, isPending } = useMutatePrintReceipt();
  const intl = useIntl();
  const toasts = useToast();

  const printReceipt = useCallback(
    (reference: string, placementId: number) => {
      print(
        { printReceiptDto: { copies: 1, placementId, type: PrintReceiptDtoTypeEnum.SALES_RECEIPT }, reference },
        {
          onError: () => {
            if (!toasts.exists(placementId.toString())) {
              toasts.pushError({
                id: placementId.toString(),
                message: <span>{intl.formatMessage({ id: 'receipt.print.error' })}</span>,
              });

              setTimeout(() => {
                toasts.remove(placementId.toString());
              }, 1000);
            }
          },
          onSuccess: () => {
            if (!toasts.exists(placementId.toString())) {
              toasts.pushSuccess({
                id: placementId.toString(),
                message: <span>{intl.formatMessage({ id: 'receipt.print.success' })}</span>,
              });
              onSuccess();
            }
          },
        }
      );
    },
    [intl, onSuccess, print, toasts]
  );

  return useMemo(
    () => ({
      isPending,
      printReceipt,
    }),
    [isPending, printReceipt]
  );
};

export default usePrintReceipt;
